const apiUrl = {
  authCheck: "/api/auth/check",
  mailCheck: "/api/user/mail/check",
  merchants: "/api/merchants",
  markets: "/api/markets",
  roles: "/api/roles?only=name,id",
  getRolesCount: "/api/roles?limit=1",
  getRole: "/api/roles/{roleId}",
  createRole: "/api/roles",
  updateRole: "/api/roles/{roleId}",
  deleteRole: "/api/roles/{roleId}",
  getPermissions: "/api/permissions?no_pagination=true&include=group",
  getPermissionsCount: "/api/permissions?limit=1",
  getPermission: "/api/permissions/{permissionId}",
  createPermission: "/api/permissions",
  updatePermission: "/api/permissions/{permissionId}",
  deletePermission: "/api/permissions/{permissionId}",
  getPermissionGroups: "/api/permissionGroups",
  getPermissionGroupsCount: "/api/permissionGroups?limit=1",
  getPermissionGroup: "/api/permissionGroups/{permissionGroupId}",
  createPermissionGroup: "/api/permissionGroups",
  updatePermissionGroup: "/api/permissionGroups/{permissionGroupId}",
  deletePermissionGroup: "/api/permissionGroups/{permissionGroupId}",
  permissionsFromRole: "/api/roles/{roleId}/permissions?no_pagination=true",
  removePermissionsFromRole: "/api/roles/{roleId}/permissions/detach",
  addPermissionsToRole: "/api/roles/{roleId}/permissions/attach",
  getAvailablePermissions: "/api/roles/{roleId}/availablePermissions",
  createCity: "/api/cities",
  getCities: "/api/cities/search?no_pagination=true",
  editCity: "/api/cities/{city}",
  editCityWithMarketDates: "/api/cities/{city}/market-dates",
  marketWithMarketDates: "/api/markets/{market}/market-dates",
  getBillingPeriods: "/api/billingPeriods",
  getSettings: "/api/settings",
  placers: "/api/placers/search?no_pagination=true",
  getStatus: "/api/status",
  searchPaymentMethods: "/api/paymentMethods/search",
  getBankAccounts: "/api/bankAccounts",
  createContact: "/api/contacts",
  getCityContact: "/api/contacts/search",
  deleteContact: "/api/contacts/{contactId}",
  editContact: "/api/contacts/{contactId}",
  getContactType: "/api/contacttype",
  setAsInvoicesRecipient: "/api/merchants/{merchantId}/invoices-recipient",
  getMarketCity: "/api/markets",
  getMarket: (marketId: number) => `/api/markets/${marketId}?include=city,market_days`,
  marketsToday: "/api/markets/today",
  getInvoicesByCity: "/api/invoices",
  getActivityDistribution: "/api/activity-distribution",
  marketWeather: "/api/market-weather",
  marketMetrics: "/api/markets",
  absences: "/api/absences",
  absence: "/api/absences/{absenceId}",
  absencesPeriod: "/api/absences-period",
  absencePeriod: "/api/absences-period/{absencePeriodId}",
  depositsStore: "/api/deposits/store",
  deposits: "/api/deposits",
  mediasSearch: "/api/medias/search",
  mediaTypes: "/api/mediaTypes",
  mediaTypesWithoutPagination: "/api/mediaTypes?no_pagination=true",
  mediaTypeAttachmentTargetCapabilities: "/api/mediaTypes/attachment-target-capabilities",
  mediaTypeAttachmentTargetDefinitions: (mediaTypeId: number) => `/api/mediaTypes/${mediaTypeId}/attachment-target-definitions`,
  cityDocumentAttachmentTargetPreview: (cityId: number | string) => `/api/cities/${cityId}/documents/attachment-target-preview`,
};
export const authUrl = {
  login: "/login",
  logout: "/logout",
  forgotPassword: "/forgot-password",
  forgotPasswordNotTenant: "/forgot-password",
  resetPassword: "/reset-password",
  tenantUser: "/api/users/{token}/tenant",
  verifyOtp: "/api/auth/verify-otp",
  resendOtp: "/api/auth/resend-otp",
};

export const backupCodesUrl = {
  status: "/api/user/backup-codes/status",
  generate: "/api/user/backup-codes/generate",
  list: "/api/user/backup-codes",
};

export const adminEmergencyUrl = {
  searchUser: "/api/admin/user/search",
  generateBypass: "/api/admin/user/{userId}/generate-bypass",
  getUserBypassCodes: "/api/admin/user/{userId}/bypass-codes",
  getUserBypassHistory: "/api/admin/user/{userId}/bypass-history",
  revokeBypassCode: "/api/admin/bypass-code/{codeId}/revoke",
};
export const emailHealthUrl = {
  status: "/api/admin/email-health/status",
  history: "/api/admin/email-health/history",
  reset: "/api/admin/email-health/reset",
  statistics: "/api/admin/email-health/statistics",
};
export const organilogSettingsUrl = "/api/organilog/settings";
export const preferenceUrl = {
  getById: "/api/user/{id}/preference",
  update: "/api/user/preference",
};

export const merchantEmailUrl = {
  updateEmailCascade: "/api/merchants/{id}/email-cascade",
};

export const pdfUrl = {
  generate: "/api/pdf/generate",
  getToken: "/api/pdf/generate/token",
  // Le back-office compose lui-même la charge utile du micro-service : il a
  // les modèles, donc les avoirs et les règlements imputés. Cette route reçoit
  // une sélection d'identifiants, pas des lignes de table.
  exportInvoices: "/api/invoices/export-pdf",
  batchStatus: (batchId: string) => `/api/pdf/batch/${batchId}/status`,
};

export const invoiceEmailUrl = {
  resend: "/api/invoices/resend-emails",
};

export const activityLogUrl = {
  list: "/api/activity-logs",
  subjectTypes: "/api/activity-logs/subject-types",
  logNames: "/api/activity-logs/log-names",
  eventTypes: "/api/activity-logs/event-types",
  users: "/api/activity-logs/users",
  bySubject: "/api/activity-logs/subject",
};

export const notificationsUrl = {
  list: "/api/notifications",
  read: "/api/notifications/{id}/read",
  readAll: "/api/notifications/read-all",
  saveToken: "/api/user/notification-token",
};

export const marketPresenceUrl = {
  arrival: "/api/mobile/market/{marketId}/presence/arrival",
  departure: "/api/mobile/market/{marketId}/presence/departure",
  list: (marketId: number, date: string) => `/api/markets/${marketId}/placer-presences?date=${date}`,
  export: (marketId: number, date: string) => `/api/markets/${marketId}/placer-presences/export?date=${date}`,
};

export const marketGeographicAnomaliesUrl = {
  list: (marketId: number, date: string) => `/api/markets/${marketId}/geographic-anomalies?date=${date}`,
  export: (marketId: number, date: string) => `/api/markets/${marketId}/geographic-anomalies/export?date=${date}`,
};

export const placerPlanningUrl = {
  calendar: "/api/placer-schedule/calendar",
  history: "/api/placer-schedule/history",
  availability: "/api/placer-schedule/availability",
  assignments: "/api/placer-assignments",
  assignment: (id: number) => `/api/placer-assignments/${id}`,
  assignmentReplacements: (id: number) => `/api/placer-assignments/${id}/replacements`,
  assignmentBatch: "/api/placer-assignments/batch",
  marketAssignment: (id: number) => `/api/placer-market-assignments/${id}`,
  scheduleMarketAssignmentChange: (id: number) => `/api/placer-market-assignments/${id}/schedule-change`,
  terminateMarketAssignment: (id: number) => `/api/placer-market-assignments/${id}/terminate`,
  correctMarketAssignmentHistory: (id: number) => `/api/placer-market-assignments/${id}/correct-history`,
  replacementBatch: "/api/placer-replacements/batch",
  replacement: (id: number) => `/api/placer-replacements/${id}`,
  cancelReplacement: (id: number) => `/api/placer-replacements/${id}/cancel`,
  absencePreview: "/api/placer-absences/preview",
  absences: "/api/placer-absences",
  absenceCoverages: (id: number) => `/api/placer-absences/${id}/coverages`,
  cancelAbsence: (id: number) => `/api/placer-absences/${id}/cancel`,
};

export const cityStatisticsUrl = {
  cityMetrics: "/api/cities/metrics",
  cityIncomeEvolution: (cityId: number) => `/api/cities/${cityId}/metrics/income-evolution`,
  cityIncomeOverview: (cityId: number) => `/api/cities/${cityId}/metrics/income-overview`,
  marketMetrics: (marketId: number) => `/api/markets/${marketId}/metrics`,
  marketIncomeOverview: (marketId: number) => `/api/markets/${marketId}/metrics/income-evolution`,
  marketsSearch: "/api/markets/search",
};

export const marketReportsUrl = {
  create: "/api/market-report",
  show: (reportId: number | string) => `/api/market-report/${reportId}`,
};

export const actionPlansUrl = {
  activeForMarket: (marketId: number) => `/api/markets/${marketId}/action-plan-items/active`,
};

/**
 * Signalements (`Event`). Les écrans historiques de `components/event/**` écrivent encore
 * leurs URLs en dur ; seul le code neuf passe par ce registre.
 */
export const eventsUrl = {
  eventTypes: "/api/event-types",
};

export const placersUrl = {
  confirmedMeterDeviations: (placerId: number | string) => `/api/placers/${placerId}/confirmed-meter-deviations`,
  /** Placiers affectés à un marché (relation Orion, non paginée côté serveur). */
  byMarket: (marketId: number) => `/api/markets/${marketId}/placers`,
};

export const subscriptionsUrl = {
  /** Dit si l'entreprise de l'abonnement peut être changée, et sinon pourquoi. */
  companyChangeEligibility: (subscriptionId: number) => `/api/subscriptions/${subscriptionId}/company-change-eligibility`,
};

export const auditPassengersUrl = {
  // Sessions
  sessions: "/api/audit-passengers/sessions",
  session: (id: string) => `/api/audit-passengers/sessions/${id}`,
  sessionComplete: (id: string) => `/api/audit-passengers/sessions/${id}/complete`,

  // Market data
  marketBillings: (marketId: number) => `/api/audit-passengers/markets/${marketId}/billings`,
  marketTenueHistoryMerchants: (marketId: number) => `/api/audit-passengers/markets/${marketId}/tenue-history-merchants`,
  marketWeather: (marketId: number) => `/api/audit-passengers/markets/${marketId}/weather`,
  marketSessions: (marketId: number) => `/api/audit-passengers/markets/${marketId}/sessions`,
  marketIncidents: (marketId: number) => `/api/audit-passengers/markets/${marketId}/events`,
  incident: (id: number) => `/api/audit-passengers/events/${id}`,
  incidentTypes: "/api/audit-passengers/incident-types",

  // Merchant data
  merchantHistory: (merchantId: number, marketId: number, date?: string | null) => `/api/audit-passengers/merchants/${merchantId}/history?market_id=${marketId}${date ? `&date=${encodeURIComponent(date)}` : ""}`,
  merchantPresence: (merchantId: number, date?: string) => `/api/audit-passengers/merchants/${merchantId}/presence${date ? `?date=${encodeURIComponent(date)}` : ""}`,
  merchantReferenceMeter: (merchantId: number) => `/api/audit-passengers/merchants/${merchantId}/reference-meter`,

  // Audit entries
  entries: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/entries`,
  entry: (id: number) => `/api/audit-passengers/entries/${id}`,

  // Checklist
  checklist: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/checklist`,
  checklistItem: (id: number) => `/api/audit-passengers/checklist/${id}`,

  // Observations
  observations: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/observations`,
  observation: (id: number) => `/api/audit-passengers/observations/${id}`,

  // Report
  reportData: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/report`,
  reportSubmit: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/report/submit`,
  validationForceReview: (sessionId: string | number) => `/api/audit-passengers/sessions/${sessionId}/validation/force-review`,
  validationFinalizeReview: (sessionId: string | number) => `/api/audit-passengers/sessions/${sessionId}/validation/finalize-review`,
  reportVersions: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/report/versions`,
  reportVersionPdf: (sessionId: string, versionId: number | string) => `/api/audit-passengers/sessions/${sessionId}/report/versions/${versionId}/pdf`,
  reportTrail: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/report/trail`,
  reportPdf: (sessionId: string) => `/api/audit-passengers/sessions/${sessionId}/report/pdf`,

  // Backoffice
  auditors: "/api/audit-passengers/auditors",
  auditor: (id: number) => `/api/audit-passengers/auditors/${id}`,
  schedules: "/api/audit-passengers/schedules",
  schedule: (id: number) => `/api/audit-passengers/schedules/${id}`,
  completed: "/api/audit-passengers/completed",
  completedExport: "/api/audit-passengers/completed/export",
  requests: "/api/audit-passengers/requests",
  requestsExport: "/api/audit-passengers/requests/export",
  request: (id: number) => `/api/audit-passengers/requests/${id}`,
  deviations: "/api/audit-passengers/deviations",
  deviationsExport: "/api/audit-passengers/deviations/export",
  referenceMeters: "/api/audit-passengers/reference-meters",
  referenceMeter: (id: number) => `/api/audit-passengers/reference-meters/${id}`,
  referenceMetersExport: "/api/audit-passengers/reference-meters/export",
  reports: "/api/audit-passengers/reports",
  reportsExport: "/api/audit-passengers/reports/export",
  settingsActionPlanCategories: "/api/audit-passengers/settings/action-plan-categories",
  settingsActionPlanCategory: (id: number) => `/api/audit-passengers/settings/action-plan-categories/${id}`,
  settingsActionPlanPriorities: "/api/audit-passengers/settings/action-plan-priorities",
  settingsActionPlanPriority: (id: number) => `/api/audit-passengers/settings/action-plan-priorities/${id}`,
  settingsChecklistTemplates: "/api/audit-passengers/settings/checklist-templates",
  settingsChecklistTemplate: (id: number) => `/api/audit-passengers/settings/checklist-templates/${id}`,
  settingsAlertRecipients: "/api/audit-passengers/settings/alert-recipients",
  settingsAlertRecipient: (id: number) => `/api/audit-passengers/settings/alert-recipients/${id}`,
};

export default apiUrl;
